import { styled } from "styled-components";

export const MonthSettlementExpensePopupWrapper = styled.div`
  width: 307px;
  border-radius: 13px;
  background: #ffffff;
  padding: 40px;
  box-sizing: border-box;
  position: absolute;
  z-index: 1000;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .header {
    display: flex;
    justify-content: space-between;

    > img {
      cursor: pointer;
    }
  }

  > .button {
    background: #6436e7;
    width: 100%;
    height: 48px;
    border-radius: 8px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
  }
`;

export const MonthSettlementExpensePopupCheckWrapper = styled.div`
  display: flex;
  gap: 10px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  align-items: center;

  > div {
    cursor: pointer;
  }
`;

export const MonthSettlementExpensePopupCheck = styled.div`
  background: #ffffff;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid #d9d9d9;
  cursor: pointer;

  > img {
    width: 10px;
  }
`;

export const MonthSettlementExpenseFilterWrapper = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  background: #ecf0f3;
  width: 100%;
  height: 464px;
  border-radius: 13px;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
  scrollbar-width: none;
`;

export const MonthSettlementExpenseFilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .main {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > img {
      width: 10px;
      height: 6px;
      cursor: pointer;
    }
  }
`;

export const MonthSettlementExpenseFilterChildren = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;

  > img {
    width: 10px;
    height: 6px;
    cursor: pointer;
  }
`;
